/**
 * Whether `@mux/mux-player` can be rendered in this browser.
 *
 * It calls `new WeakRef()` internally with no polyfill path, so on Chrome <84 and Safari <14.5 it
 * throws asynchronously during playback setup (CHANGE-93371, Sentry 7363973254). Every site that
 * renders `MuxPlayer` has to check this first - the original fix assumed there would only ever be
 * one, and a second one appeared.
 */
export function isMuxPlayerSupported(): boolean {
	return typeof WeakRef !== 'undefined';
}
